import { faClose } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Block, Col, Row, useClasses } from "../";
import React from "react";
const styles = (theme) => ({
    shadow: {
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        position: "fixed",
        width: "100%",
        height: "100%",
        zIndex: "200",
        left: 0,
        top: 0,
    },
    box: {
        width: "100%",
        maxWidth: "600px",
        margin: "32px auto 0px",
        textAlign: "left",
    },
    title: {
        backgroundColor: (props) => theme.palette.get(props.variant || "primary"),
        color: "#fff",
        margin: "-8px -16px 16px !important",
        padding: "8px 16px !important",
        fontSize: "1.2rem",
    },
    actions: {
        textAlign: "right !important",
    },
    icon: {
        cursor: "pointer",
    },
});
export default function LightBox(props) {
    const classes = useClasses(styles, props);
    if (props.open)
        return (React.createElement("div", { className: classes.shadow, onClick: props.onClose },
            React.createElement("div", { className: classes.box, onClick: (e) => {
                    e.stopPropagation();
                } },
                React.createElement(Block, { padding: "8px 16px 16px 16px" },
                    React.createElement(Row, { override: { row: classes.title } },
                        React.createElement(Col, { xs: "auto" }, props.title),
                        React.createElement(Col, { xs: "rest-fixed", override: { col: classes.actions } },
                            React.createElement(FontAwesomeIcon, { icon: faClose, className: classes.icon, onClick: () => {
                                    props.onClose();
                                } }))),
                    props.children))));
    else
        return React.createElement(React.Fragment, null);
}
